import { Resource } from "pages/EmailBuilder/EmailBuilder";
import { InclusionCriteria } from "pages/Segment/MySegment";

export enum SegmentType {
  AUTOMATIC = "automatic",
  MANUAL = "manual",
  STATIC = "static",
}

export interface Segment {
  id: string;
  name: string;
  inclusionCriteria: InclusionCriteria;
  isFreezed: boolean;
  resources: Resource[];
  updatedAt?: Date;
  type: SegmentType;
  audienceSize?: number;
  status: string;
}

export enum SegmentStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Failed = 'Failed',
  Draft = 'Draft',
}